export const phoneText = 'or call us at 718-878-4442';